<router-outlet></router-outlet>
<app-alert></app-alert>
<ppgt-confirm></ppgt-confirm>
<app-loader *ngIf="loading"></app-loader>

<app-add-delivery *ngIf="showNewDeliveryAside"
                  (closeAside)="closeNewDeliveryAside()"></app-add-delivery>
